const VALID_API_REDIRECT_PATHS = [
  "/auth/accept-invite",
  "/auth/accept-org-invite",
  "/api/v1/mcp/login",
  "/api/hubspot/marketplace/install",
];

const VALID_MCP_APP_RETURN_TO_PATHS = ["/mcp-connect"];

export const isValidApiRedirectOnLogin = (
  returnTo: string,
  apiBaseUrl = import.meta.env.VITE_API_BASE_URL,
) => {
  const { host: apiHost, protocol: apiProtocol } = new URL(apiBaseUrl);

  try {
    const returnToUrl = new URL(returnTo);

    if (returnToUrl.protocol !== apiProtocol || returnToUrl.host !== apiHost) {
      return false;
    }

    return VALID_API_REDIRECT_PATHS.includes(returnToUrl.pathname);
  } catch {
    // Invalid URL format
    return false;
  }
};

export const isMcpAuthReturnTo = (
  returnTo: string | null | undefined,
  apiBaseUrl = import.meta.env.VITE_API_BASE_URL,
) => {
  if (!returnTo) {
    return false;
  }

  if (returnTo.startsWith("/")) {
    try {
      const returnToUrl = new URL(returnTo, "https://app.hightouch.com");
      return (
        VALID_MCP_APP_RETURN_TO_PATHS.includes(returnToUrl.pathname) &&
        Boolean(returnToUrl.searchParams.get("external_auth_id"))
      );
    } catch {
      return false;
    }
  }

  try {
    const { host: apiHost, protocol: apiProtocol } = new URL(apiBaseUrl);
    const returnToUrl = new URL(returnTo);

    return (
      returnToUrl.protocol === apiProtocol &&
      returnToUrl.host === apiHost &&
      returnToUrl.pathname === "/api/v1/mcp/login" &&
      Boolean(returnToUrl.searchParams.get("external_auth_id"))
    );
  } catch {
    return false;
  }
};

// Shown by the login forms when the API answers 429.
export const TOO_MANY_ATTEMPTS_MESSAGE =
  "Too many attempts. Wait a few minutes, then try again.";
